import { Quill } from 'react-quill'

const Embed = Quill.import('blots/embed')

// We want an Embed over an Inline here so that a single CR deletes the whole tag.
//
// https://github.com/quilljs/quill/blob/develop/blots/embed.js#L7
class VariableBlot extends Embed {
  static blotName = 'variable'

  static tagName = 'SPAN'

  static className = 'ql-variable'

  static create(value) {
    const node = super.create(value)

    node.innerText = value

    return node
  }

  // https://github.com/quilljs/parchment/blob/master/src/blot/abstract/leaf.ts#L9
  static value(node) {
    // Sometimes quill formats childNodes with extra text padding, and we want to remove those since they get converted
    // into unicode \ufeff values, and quill loses the original value completely.
    const leafNode = Array.from(node.childNodes).filter(
      n => n.nodeName === 'SPAN'
    )[0]

    return leafNode.firstChild.textContent
  }

  // This method is responsible for setting the editor state again
  static formats(node) {
    return node.innerText
  }
}

// https://github.com/quilljs/quill/blob/develop/core.js
Quill.register('formats/variable', VariableBlot)
